import RoleDisplay from "./roleDisplay";

export default class RoleCheckedDisplay extends RoleDisplay {
  isSelected: boolean;
  constructor(code: string, displayName: string, isSelected: boolean) {
    super(code, displayName);
    this.isSelected = isSelected;
  }
}
